export default "__VITE_PUBLIC_ASSET__acbdc609__"